import { formattedChildTariffsData } from './utils'

export type LinkedTariffsType = Partial<{
	parentTariffName: string
	parentTariffId: string
	childTariffs: {
		id: string
		name: string
		url: string
		expired: boolean
		expiryDate: string
		cuiPanel: string
	}[]
	businesses: { key: string; value: string; text: string }[] | []
	cuiPanels: { key: string; value: string; text: string }[] | []
	errors: ['Permission denied' | 'Tariff does not exist']
}>

export type AddMultipleModalValues = {
	tariffBandId: string
	customer: string[]
	tariffName: string
	cuiPanel: string
	startDate: Date
	endDate: Date
}

export type AddMultipleModalErrors = {
	customer?: string
	tariffName?: string
	cuiPanel?: string
	startDate?: string
	endDate?: string
}

export type ChildTariffData = {
	tariff: {
		data: string
		link: string
	}
	id: string
	expired: string
	checked: boolean
}[]

export type FormattedChildTariffsData = ReturnType<typeof formattedChildTariffsData>

export type UpdateLinkedTariffsResponse = {
	status: 'success' | 'failure'
	error?: string
	unableToUpdateTariffs?: string[]
}

export type SelectOneRow = {
	type: 'selectOneRow'
	payload: { rowId: string; checked: boolean }
}

export type SelectAllRows = {
	type: 'selectAllRows'
	payload: boolean
}
